import React from "react";

interface PopUpMessageProps {
  onOkClick: () => void;
  message?: string;
  buttonText?: string;
  type: string;
  isOpen: boolean;
}

const PopUpMessage: React.FC<PopUpMessageProps> = ({
  onOkClick,
  message = "",
  isOpen,
  buttonText = "",
  type,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        inset: "0",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        display: isOpen ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "100%",
          maxWidth: "500px",
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <p
          style={{
            fontSize: "18px",
            fontWeight: "600",
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          {message}
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <button
            onClick={onOkClick}
            style={{
              padding: "12px 20px",
              backgroundColor: "#FFE500",
              color: "black",
              fontWeight: "600",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              width: "fit-content",
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopUpMessage;
